
import CountrycodeWithTextfield from "../common/countrycode-with-textfield.vue";
const DEFAULT_MOBILE_NUMBER = {
  country_code: "+91",
  number: ""
};
export default {
  components: {
    CountrycodeWithTextfield
  },
  data() {
    return {
      isPhoneValid: true,
      selectedMode: "email",
      email: "",
      mobileNumber: DEFAULT_MOBILE_NUMBER,
      role: "",
      loading: false,
      valid: false,
      selectRule: [(v) => !!v || "Please select a Role"]
    };
  },
  computed: {
    isEmailSelected() {
      return this.selectedMode === "email";
    },
    isFormValid() {
      return this.valid && (this.isEmailSelected || this.isPhoneValid);
    }
  },
  methods: {
    validate() {
      this.valid = this.$refs.form.validate();
    },
    modeChanged() {
      if (this.isEmailSelected) {
        this.mobileNumber = DEFAULT_MOBILE_NUMBER;
      } else {
        this.email = "";
      }
      this.$refs.form.resetValidation();
    },

    handleAddMember() {
      console.log("added member");
    }
  }
};
